<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  .helper-text {
    display: flex;
    flex-direction: row;
    gap: utils.in_rem(4px);
    padding: utils.in_rem(6px) utils.in_rem(4px) 0 utils.in_rem(4px);
    @include colors.color(textGrey);
    @include mixins.caption();

    &.error {
      @include colors.color(systemError_100);
    }
    &.warning {
      @include colors.color(systemWarning_100);
    }
  }
</style>

<script>
  import IconScale from "../IconScale.svelte";

  export let helperText;
  export let state;
</script>

<span class="helper-text {state}">
  {#if state === "error" || state === "warning"}
    <IconScale class="fa-solid fa-circle-info" size="xs" />
  {/if}
  {helperText}
</span>
